import { render, staticRenderFns } from "./zujinForm.vue?vue&type=template&id=788c0c8e&scoped=true"
import script from "./zujinForm.vue?vue&type=script&lang=js"
export * from "./zujinForm.vue?vue&type=script&lang=js"
import style0 from "./zujinForm.vue?vue&type=style&index=0&id=788c0c8e&prod&scoped=true&lang=less"
import style1 from "./zujinForm.vue?vue&type=style&index=1&id=788c0c8e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c0c8e",
  null
  
)

export default component.exports